module.exports = __webpack_public_path__ + "img/IMG_1022-Edit.ccdc70b5.jpg";